/**
 * Simple HttpError class
 */
export class HttpError extends Error {
    public status: number; // HTML Codes

    /**
     *
     * @param {number} status - The HTML status code
     * @param {string} message - This is the message shown to the client
     */
    constructor(status: number, message: string) {
        super(message);

        // this.message set in constructor
        this.name = 'HttpError';
        this.status = status;

        Error.captureStackTrace(this, HttpError);
    }
}

export function httpErrorMessage(status: number, body: unknown): string {
    if (typeof body === 'string' && body.trim()) return body;
    if (body && typeof body === 'object') {
        for (const key of ['clientMessage', 'message']) {
            const value = (body as Record<string, unknown>)[key];
            if (typeof value === 'string' && value.trim()) return value;
        }
    }
    return `Request failed (HTTP ${status})`;
}
